import { render, staticRenderFns } from "./PageForChina.vue?vue&type=template&id=03c8e5c8"
import script from "./PageForChina.vue?vue&type=script&lang=js"
export * from "./PageForChina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports